import { iDataColumn } from "../EmsSetup/TenantAPI";
import { iMailboxConfig } from "../Logic/config";
import { CallEmsApi, iEmsApiResponse, iEmsApiResponseBody } from "../Logic/TenantAPI";

export interface Mailbox {
    id?: number;
    name: string;
    serviceCentreID: number;
    managerID: number;
    senderPrefix: string;
    emailAddress: string;
    pop3Server: string;
    pop3Port: number | null;
    pop3Username: string;
    pop3Password: string;
    smtpServer: string;
    smtpPort: number | null;
    enqRefPrefix: string;
    enqRefSuffix: string;
    slaTimeout: number;
    slaReminder: number;
    slaAlarm: number;
    telephone: string;
    facsimile: string;
    boxEnabled: string;
    slaTouchTimeout: number;
    slaTouchReminder: number;
    slaTouchAlarm: number;
    flags: number;
    priority: number;
    popAfter: number;
    popBefore: number;
    misModelID: number;
    autoResponse: string;
    everyEmail: string;
    responseExclusionMasks: string;
    responseTemplateID: number | null;
    boxSlaModelID: number;
    userSlaModelID: number;
    responseSlaModelID: number;
    activeCycle: number;
    productionTimes: mailboxProductionTime[];
    mailboxConfiguration: { pop3Settings?: string; smtpSettings?: string };
}

export interface mailboxProductionTime {
    statusID: number;
    productionTime: number;
}

export interface GetMailboxesResponse {
    items: MailboxList[];
}
export interface GetMailboxResponse {
    mailbox: Mailbox;
}

export interface MailboxList {
    id: number;
    name: string;
}

export interface MailboxMember {
    userID: number;
    roleID: number;
}

export interface MailboxMemberResponse {
    items: MailboxMember[];
}
export interface MailboxTemplatesResponse {
    items: iDataColumn[];
}
export interface MailboxMembers {
    mailboxID: number;
    members: MailboxMember[];
}

export interface iUpdateMailboxTemplates {
    templates: number[];
}

export async function GetMailboxes(tenantToken: string): Promise<iEmsApiResponseBody<GetMailboxesResponse>> {
    const results = await CallEmsApi<GetMailboxesResponse>(tenantToken, "GET", "Mailboxes");
    if (results.isOk && results.data) {
        results.data.items.sort((a, b) => a.name.localeCompare(b.name));
    }
    return results;
}

export async function GetMailbox(tenantToken: string, id: number): Promise<iEmsApiResponseBody<GetMailboxResponse>> {
    return await CallEmsApi<GetMailboxResponse>(tenantToken, "GET", `Mailboxes/${id}`);
}

export async function GetMailboxEditorConfig(
    tenantToken: string,
    id: number,
): Promise<iEmsApiResponseBody<iMailboxConfig>> {
    return await CallEmsApi<iMailboxConfig>(tenantToken, "GET", `Config/Editor/${id}`);
}

export async function CreateMailbox(tenantToken: string, request: Mailbox): Promise<iEmsApiResponseBody<any>> {
    return await CallEmsApi<any>(tenantToken, "POST", `Mailboxes`, { mailbox: request });
}

export async function UpdateMailbox(
    tenantToken: string,
    id: number,
    request: Mailbox,
): Promise<iEmsApiResponseBody<any>> {
    return await CallEmsApi<any>(tenantToken, "PUT", `Mailboxes/${id}`, { mailbox: request });
}

export async function UpdateMailboxEditorConfig(
    tenantToken: string,
    id: number,
    request: iMailboxConfig,
): Promise<iEmsApiResponseBody<any>> {
    return await CallEmsApi<any>(tenantToken, "POST", `Mailboxes/${id}/MailboxEditorConfig`, {
        EditorConfig: { EditorConfiguration: request },
    });
}

// Membershp //

export async function GetMembership(
    tenantToken: string,
    id: number,
): Promise<iEmsApiResponseBody<MailboxMemberResponse>> {
    return await CallEmsApi<MailboxMemberResponse>(tenantToken, "GET", `Mailboxes/${id}/Members`);
}

export async function UpdateMembership(
    tenantToken: string,
    id: number,
    request: MailboxMembers,
): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "PUT", `Mailboxes/${id}/Members`, request);
}

export async function GetMailboxTemplates(
    tenantToken: string,
    id: number,
): Promise<iEmsApiResponseBody<MailboxTemplatesResponse>> {
    return await CallEmsApi<MailboxTemplatesResponse>(tenantToken, "GET", `Mailboxes/${id}/Templates`);
}
export async function UpdateMailboxTemplates(
    tenantToken: string,
    id: number,
    request: iUpdateMailboxTemplates,
): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "PUT", `Mailboxes/${id}/Templates`, request);
}
